import React from "react";
import { Typography, Form, Input, Select, Button, Row, Col, Card } from "antd";
import "./ContactUs.css";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const ContactUs: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form submitted:", values);
    // Handle form submission here
  };

  return (
    <div className="contact-us-page">
      {/* Page Header */}
      <div className="contact-header">
        <img
          src="/images/contact-us-icon.svg"
          alt="Contact Us"
          className="contact-icon"
        />
        <Title level={2} className="contact-title">
          Contact Us
        </Title>
      </div>

      {/* Send Message Section */}
      <div className="send-message-section">
        <Title level={3} className="send-message-title">
          Send Message
        </Title>

        <Row gutter={[32, 32]} className="contact-content">
          {/* Contact Form */}
          <Col xs={24} lg={14}>
            <Card className="contact-form-card">
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className="contact-form"
              >
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please select a subject" },
                  ]}
                  className="contact-form-item"
                >
                  <Select
                    placeholder="Select a report"
                    className="contact-select"
                    suffixIcon={
                      <svg width="10" height="5" viewBox="0 0 10 5" fill="none">
                        <path d="M5 5L0 0H10L5 5Z" fill="#4D4D4D" />
                      </svg>
                    }
                  >
                    <Option value="technical">Technical Issue</Option>
                    <Option value="payment">Payment Question</Option>
                    <Option value="application">Application Support</Option>
                    <Option value="general">General Inquiry</Option>
                    <Option value="other">Other</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                  className="contact-form-item"
                >
                  <Input
                    placeholder="Enter your name"
                    className="contact-input"
                  />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                  className="contact-form-item"
                >
                  <Input
                    placeholder="Enter your email"
                    className="contact-input"
                  />
                </Form.Item>

                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter your message" },
                  ]}
                  className="contact-form-item message-item"
                >
                  <TextArea
                    rows={8}
                    placeholder="Enter your message"
                    className="contact-textarea"
                  />
                </Form.Item>

                <div className="form-submit-container">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>

          {/* Contact Information */}
          <Col xs={24} lg={10}>
            <div className="contact-info-container">
              <div className="contact-info-background">
                <div className="background-shape-1"></div>
                <div className="background-shape-2"></div>
              </div>

              <Card className="contact-info-card">
                <div className="contact-info-content">
                  <div className="contact-section">
                    <span className="contact-label">Contact by Phone</span>
                    <br />
                    <span className="contact-value">1 (619) 566 - 1929</span>
                  </div>

                  <div className="contact-section">
                    <span className="contact-label">Hours of Operation</span>
                    <br />
                    <span className="contact-value">
                      Monday-Thursday 8:00 AM - 4:00 PM PST
                      <br />
                      Friday 8:00 AM - 1:00 PM PST
                    </span>
                  </div>

                  <div className="contact-section">
                    <span className="contact-label">Cardholder Services</span>
                    <br />
                    <span className="contact-value">1-844-725-8818</span>
                    <br />
                    <a
                      href="https://bpscardaccount.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      bpscardaccount.com
                    </a>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContactUs;
